import { useTheme } from '@emotion/react'
import { ArrowBack, Description, Edit, EditOutlined, Group, RemoveRedEyeOutlined } from '@mui/icons-material'
import { Box, Button, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import { FetchAllStartupFeedbacks } from 'api/profile'
import { FetchAssessments, FetchFunding, FetchRoundViewDetails } from 'api/org/startups'
import Cookies from 'js-cookie'
import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import AsyncTableListing from 'ui-components/AsyncTableListing'
import { capitalizedSentence, handleDateValues, navigateToDomain, navigateToMain } from 'utils/index'
import placeHolderImageFunding from 'assets/no_data_images/Startups/funding_startups.svg'
import Pipelines from 'views/backrr_startups/viewDetails/PipelineInvestors'
import moment from 'moment'


const Assessments = ({ startup_id, isAdmin, startup_slug }) => {
    const theme = useTheme();
    const [selectedRound, setSelectedRound] = React.useState(null);
    const details = useSelector((state) => state?.startupDetails?.data);
    const navigate = useNavigate()
    let cookieStartupId = Cookies.get("startup_id");

    const columns = [
        { Header: 'Assessment Name', accessor: 'assessment_type', minWidth: 100, align: 'start', fixed: true },
        { Header: 'Date taken', accessor: 'date', minWidth: 150, align: 'center' },
        { Header: 'Status', accessor: 'assessment_status', minWidth: 150, align: 'center' },
        { Header: 'Report Type', accessor: 'report_type', minWidth: 150, align: 'center', status: true },
        { Header: 'Score', accessor: 'score', minWidth: 150, align: 'center' },
        { Header: 'View Report', accessor: 'actions', minWidth: 80, align: 'center' }
    ];

    const [page, setPage] = React.useState(1);
    const [limit, setLimit] = React.useState(10);
    const [sort, setSort] = React.useState(-1);
    const [search, setSearch] = React.useState(-1);
    const { data: assessments, isLoading: isLoadingAssessments, refetch: refetchListing } = FetchAssessments({ id: cookieStartupId ? cookieStartupId : '' })


    const formatedFundingData = assessments?.data?.map((item) => {
        return {
            ...item,
            assessment_type: capitalizedSentence(item?.type),
            date: moment(item?.created_at).format("DD-MMM-YYYY HH:mm:ss"),
            assessment_status: item?.is_active === false ? "Completed" : "Left",
            score: item?.responses && Array.isArray(item?.responses) ? !Number.isNaN(Number(item.responses?.find(item => item)?.overall_percentage)) ? Number(item.responses?.find(item => item)?.overall_percentage || 0).toFixed(0) + "%" : "-" : (item?.overall_percentage ? !Number.isNaN(Number(item?.overall_percentage)) ? Number(item?.overall_percentage || 0).toFixed(0) + "%" : "-" : "-"),
        }
    })

    const RowActions = ({ row, cell }) => {
        // console.log(row,"rrrrrrrrrrrrr");

        const original_row = row?.original;

        return original_row?.last_response_id ? <Box width={"100%"} onClick={() => {

        }} display={"flex"} alignItems={"center"} justifyContent={"center"} gap={0.5} sx={{ textDecoration: "underline", textUnderlineOffset: '5px', textDecorationColor: theme.palette.customColors.indigo600, cursor: 'pointer' }} >
            <Tooltip title="View">
                <Button sx={{ minWidth: "1rem" }} onClick={() => {
                    window.open(navigateToDomain("main", `startup/${original_row?.type}/report/${original_row?.last_response_id}?admin=true`))
                }}>
                    <RemoveRedEyeOutlined
                        sx={{ color: theme.palette.customColors.indigo700 }}
                    />
                </Button>
            </Tooltip>
        </Box> : "-"
    }

    const Listing = () => {
        return (
            isLoadingAssessments ?
                <Grid item xs={12} height={"100dvh"} sx={{ width: '100%', padding: "2rem", paddingLeft: "2rem !important", paddingTop: "0rem !important", bgColor: theme.palette.customColors.yellow_bg }} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                    <Box className='skeleton' minHeight={"70dvh"} sx={{ borderRadius: "8px", border: `1px solid ${theme.palette.customColors.b50}` }} marginTop={0}>

                    </Box>
                </Grid>
                :
                <Box width={"100%"} paddingLeft={"2rem"} maxWidth={"100%"} overflow={"hidden"} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }}>
                    <AsyncTableListing
                        // isLoading={isLoadingFeedbacks}
                        columns={columns}
                        data={formatedFundingData}
                        noDataPlaceHolderImage={placeHolderImageFunding}
                        noDataTitle='No Assessment taken'
                        noDataSubTitle='It seems like there are no Assessments taken.'
                        page={page}
                        setPage={setPage}
                        limit={limit}
                        setLimit={setLimit}
                        count={10}
                        // tabValue={value}
                        // title={"Investors"}
                        // chipText={`${data?.length}${isSmallScreen ? "" : " Investors"}`}
                        // actions={Actions}
                        pagination={false}
                        RowActions={RowActions}
                        sx={{ borderRadius: '8px', border: formatedFundingData?.length > 0 ? `1px solid ${theme.palette.customColors.b50}` : "none", bgcolor: formatedFundingData?.length > 0 ? "white" : "transparent" }}

                    // refetchListing={refetchListing}
                    />
                </Box>
        )
    }


    return (
        <>
            <Grid container xs={12} pt={2} pb={0} spacing={2} display={"flex"} justifyContent={"space-between"} marginLeft={0} alignContent={"flex-start"} >
                {isAdmin && selectedRound && <Grid container xs={12} spacing={2} paddingInline={{ xs: "0.5rem !important", sm: '1rem !important', md: '1rem !important', lg: '2rem !important' }} display={"flex"} justifyContent={"space-between"}>
                    <Grid item container alignItems={"center"} >
                        <IconButton onClick={() => {
                            setSelectedRound(null)
                        }}>
                            <ArrowBack />
                        </IconButton>
                        <Typography fontWeight={500}>
                            {selectedRound?.round_name} Investors
                        </Typography>
                    </Grid>
                </Grid>}
                {isAdmin ? selectedRound ? <Pipelines inRound={true} round_id={isAdmin ? selectedRound?._id : null} /> : <Listing /> : <Listing />}

                {/* </Grid>} */}
                {/* <Grid item xs={2} lg={2}> */}
            </Grid>
        </>
    )
}

export default Assessments
